import { yamadumiApi } from '../yamadumi-api'

/**
 * DELETE /api/supplier/hearing/status/itemのゲートウェイクラス
 */
export class DeleteSupplierHearingStatusItemGateway {
  /** 業者ヒアリング状況確認-取消 */
  static deleteSupplierHearingStatusItem = async (
    simulationYm: string,
    supplierCd: string,
    supplierBranchCd: string,
    factoryCd: string,
    expenseCd: string
  ) => {
    const params = {
      simulationYm,
      supplierCd,
      supplierBranchCd,
      factoryCd,
      expenseCd
    }
    return await yamadumiApi.delete('/api/supplier/hearing/status/item', params)
  }
}
